import { Link } from "react-router-dom";

function Unfind() {
    return (
        <div className="unfind container__blog general-margin_top">
            <h1 className="fw-bold">Not found 404 😢</h1>


            <Link className="btn btn-outline-info back-btn" to="/"> ← Back </Link>
        </div>
    );
}

export default Unfind;
